import { render, staticRenderFns } from "./response.vue?vue&type=template&id=333060a4&scoped=true"
import script from "./response.vue?vue&type=script&lang=js"
export * from "./response.vue?vue&type=script&lang=js"
import style0 from "./response.vue?vue&type=style&index=0&id=333060a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333060a4",
  null
  
)

export default component.exports